import { Modal, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { URInput } from '../../../../shared/widgets/input';
import { config } from './config';
import sort from '../../../../styles/images/sort.svg';
import onedrive from '../../../../styles/images/onedrive.svg';
import filter from '../../../../styles/images/filter.svg';
import yellowfolder from '../../../../styles/images/yellowfolder.svg';
import { TPIService } from '../../../../base/tpiService';
import { excelFormats, getChildren, getFileSize, imageFormat, mp3Formats,
  pptFormats, wordFormats, zipFormats } from '../../../../base/utils';
import notes from "../../../../styles/images/notessvg.svg";
import iconimage from "../../../../styles/images/grid_image.svg";
import iconmusic from "../../../../styles/images/grid_music.svg";
import iconpdf from "../../../../styles/images/grid_pdf.svg";
import iconppt from "../../../../styles/images/grid_ppt.svg";
import iconword from "../../../../styles/images/grid_word.svg";
import iconxls from "../../../../styles/images/grid_xls.svg";
import iconzip from "../../../../styles/images/grid_zip.svg";
import moment from 'moment';
import store from '../../../../context/store/store';
const OneDriveStorageModal = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isFileStore,setFileStore] = useState<Array<any>>([]);
  const [tempFileStore,setempFileStore] = useState<Array<any>>([]);
  const [token,setToken] = useState<string>('');
  const [toggleName,setToggleName] = useState<boolean>(false);
  const [toggleModified,setToggleModified] = useState<boolean>(false);
  const [toggleSize,setToggleSize] = useState<boolean>(false);
  const [toggleView, setToggleView]= useState<boolean>(false);
  let meetingReducer: any = store.getState().meetingReducer;
  const {planBased} =meetingReducer;
  const [oneDriveAttachBtn, setOneDriveAttachBtn] = useState(false);
  const authUrl = [
    "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=" +
          config.oneDrive.appId,
    "scope=" + config.oneDrive.scope,
    "response_type=token",
    "redirect_uri=" + config.siteUrl
  ].join("&");

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const getFileData=(id: any = "",token:string)=>{

    getChildren(id,token).then((data:any)=>{
      if(data?.error?.code==="InvalidAuthenticationToken" || !data){
        window.open(
          authUrl,
          "sharer",
          "toolbar=0,status=0,width=900,height=518,top=120,resizable=0 left=500,right=200"
        );
      } else {
        showModal();
        setFileStore(data);
        setempFileStore(data);
      }
    //   this.setState({drivefiles:data, show:true});
      
    });
  };
  const reInitOneDrive = async() => {
    TPIService.commonBridgeAuth("one-drive");
    const dropboxStorage:any = localStorage.getItem('one-drive');
    const dropboxStore:any = JSON.parse(dropboxStorage);
    const dropbox = await TPIService.getClientsCloud("one-drive");
    if(dropboxStore && dropboxStore.access_token && dropbox &&
        dropbox.statusCode===200 && Array.isArray(dropbox.onedrive) &&
    dropbox.onedrive.length>0 && dropbox.onedrive[0].onedrive){
      getFileData("",dropbox.onedrive[0].onedrive);
      setToken(dropbox.onedrive[0].onedrive);
    //   openDropBox();
    //   await TPIService.fetchDropBoxUserFiles
    //   (dropboxStore.access_token,"",{dropbox:dropbox.onedrive[0].dropbox,path:""});
    //   setTokens(dropbox.onedrive[0].dropbox);
    } else {
      window.open(
        authUrl,
        "sharer",
        "toolbar=0,status=0,width=900,height=518,top=120,resizable=0 left=500,right=200"
      );
    }
  };

  const onButtonClickHandler = (mimetype:string,filename:string,url:string, drive:any) => {
    if(drive?.folder){
      getFileData(drive?.id,token);
    }
    else{
      TPIService.downloadOneDriveFile(filename, mimetype, url,"");
      setTimeout(()=>handleCancel(),1000);
    }
  
  };

  useEffect(()=>{

  },[token]);

  useEffect(() => {
   
    // {Chat attach file - OneDriveFeature}
    const OneDriveFeature = planBased.find((item:any) => item.featureid === 791);
    if (OneDriveFeature && OneDriveFeature.value1 === "Yes") {
      setOneDriveAttachBtn(false); 
    } else {
      setOneDriveAttachBtn(true);
    }
    
  }, [planBased]); 

  // Authentication url
  const updateInputSearch = (event:any) =>{
    const toggleFileStatus = tempFileStore.slice();
    const finalToggle:Array<any> = toggleFileStatus.filter((values:any)=>values.name.toLowerCase()
      .indexOf(event.target.value.toLowerCase())>-1);
    setFileStore(finalToggle);
  };

  const dateSorting = () =>{
    if(!toggleModified){
      const toggleFileStatus = tempFileStore.slice();
      toggleFileStatus.sort((a,b)=>new Date(a?.lastModifiedDateTime).getTime()-
      new Date(b?.lastModifiedDateTime).getTime());
      setFileStore(toggleFileStatus);
      setToggleModified(true);
    } else {
      const toggleFileStatus = tempFileStore.slice();
      setToggleModified(false);
      setFileStore(toggleFileStatus);
    }
  };

  const sizeSorting = () =>{
    if(!toggleSize){
      const toggleFileStatus = tempFileStore.slice();
      toggleFileStatus.sort((a:any, b:any) => a?.size - b?.size);
      setFileStore(toggleFileStatus);
      setToggleSize(true);
    } else {
      const toggleFileStatus = tempFileStore.slice();
      toggleFileStatus.sort((a:any, b:any) => b?.size - a?.size);
      setToggleSize(false);
      setFileStore(toggleFileStatus);
    }
  };
  const nameSorting = () =>{
    if(!toggleName){
      const toggleFileStatus = tempFileStore.slice();
      toggleFileStatus.sort((a:any, b:any) => a.name.localeCompare(b.name, navigator.languages[0] ||
        navigator.language, {numeric: true, ignorePunctuation: true}));
      setFileStore(toggleFileStatus);
      setToggleName(true);
    } else {
      const toggleFileStatus = tempFileStore.slice();
      setToggleName(false);
      setFileStore(toggleFileStatus);
    }
 
  };
  return (<>
    <li className={`${oneDriveAttachBtn ? 'disabledIcon':''}`} onClick={reInitOneDrive}>
      <span className="icon_cloud"></span> OneDrive
    </li>
    <Modal visible={isModalVisible} className="cloudstorages onedrive">
      <div className="modalheaders">
        <h2><img src={onedrive} alt=""/>One Drive</h2>
        <ul>
          <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Close'}>
            <span className="icon_close" onClick={handleCancel}></span></Tooltip></li>
        </ul>
      </div>
      <div className="previewsections">
        <div className="topslayers">
          <h4 onClick={()=> getFileData("",token)}>Files
            <span className="icon_down-arrow"></span></h4>
          <div className="rightsectioncloud">
            <URInput placeHolder="Search" className="leftbarsearch" onChange={updateInputSearch}/>
            <ul>
              <li><img src={sort} alt=""/>Sort<span className="icon_expandarrow"></span></li>
              <li onClick={()=>setToggleView(!toggleView)}><img src={filter} alt=""/>
                <span className="icon_expandarrow"></span></li>
            </ul>
          </div>
        </div>
        {!toggleView && <div className="listviewstorage">
          <div className="titletag">
            <div className=""><span className="icon_taskfill1"></span></div>
            <div className="" onClick={()=>nameSorting()}>Name<span className="icon_expandarrow"></span></div>
            {/* <div className="">Modified<span className="icon_expandarrow"></span></div> */}
            <div className="" onClick={()=>dateSorting()}>Modified By<span className="icon_expandarrow"></span></div>
            <div className="" onClick={()=>sizeSorting()}>File Size<span className="icon_expandarrow"></span></div>
          </div>
          <div className="scroller valuetags">

            {Array.isArray(isFileStore) && isFileStore.length>0 && isFileStore.map((value:any, index:number)=>{
              const fileExt = value.name.split('.').pop();
              return(<div className="titletag" key={index}  onClick={() =>
                onButtonClickHandler(
                  value?.file?.mimeType,
                  value.name,
                  value?.["@microsoft.graph.downloadUrl"],
                  value
                )
              } >
                <div className="" >    <img   src={value.folder ? yellowfolder:
                  fileExt==="pdf" ? iconpdf : pptFormats.indexOf(fileExt)>-1 ? iconppt:
                    wordFormats.indexOf(fileExt)>-1 ? iconword: excelFormats.indexOf(fileExt)>-1?
                      iconxls: zipFormats.indexOf(fileExt)>-1? iconzip : mp3Formats.indexOf(fileExt)>-1?
                        iconmusic :  imageFormat.indexOf(fileExt)>-1?  iconimage:   notes} alt=""/></div>
                <div className="">{value.name.slice(0, 24) +
                        (value.name.length > 24 ? "..." : "")}</div>
                <div className="">{moment(value?.lastModifiedDateTime).format('DD-MM-YYYY')}</div>
                {/* <div className="">{value.name.slice(0, 10) +
                        (value.name.length > 10 ? "..." : "")}</div> */}
                <div className="">{getFileSize(value?.size)}</div>
              </div>);
            })}
      
          </div>
        </div>}
        {toggleView &&<div className="gridviewstorage">
          <div className="scrollerhover valuetags">
            <div className="titletag">
              {Array.isArray(isFileStore) && isFileStore.length>0 && isFileStore.map((value:any, index:number)=>{
                const fileExt = value.name.split('.').pop();
                
                return(
                  <div className="gridlistings"  key={index}>
                    <img    onClick={() =>
                      onButtonClickHandler(
                        value?.file?.mimeType,
                        value.name,
                        value?.["@microsoft.graph.downloadUrl"],
                        value
                      )
                    } src={value.folder ? yellowfolder:
                      fileExt==="pdf" ? iconpdf : pptFormats.indexOf(fileExt)>-1 ? iconppt:
                        wordFormats.indexOf(fileExt)>-1 ? iconword: excelFormats.indexOf(fileExt)>-1?
                          iconxls: zipFormats.indexOf(fileExt)>-1? iconzip : mp3Formats.indexOf(fileExt)>-1?
                            iconmusic :  imageFormat.indexOf(fileExt)>-1?  iconimage:   notes} alt=""/>
                    {value.name.slice(0, 10) +
                        (value.name.length > 10 ? "..." : "")}<b>
                      {moment(value?.lastModifiedDateTime).format('DD MMM YY')}</b>
                  </div>
            
                );
              })}
            </div>
          </div>
        </div>}
      </div>
    </Modal></>);
};


export default OneDriveStorageModal;